export const APP_TITLE = 'Evidence Collection';

export const LABELS = {
  page: {
    plotHeading: 'Plot',
    partialNotice:
      'Some documents could not be listed right now. Reload the page to try again.',
    empty: 'No documents have been uploaded for this plot.',
    loading: 'Loading documents',
    loadError: 'The documents could not be loaded. Please try again.',
    rateLimited: 'Too many requests. Please wait a moment and try again.',
    retry: 'Try again'
  },
  table: {
    filename: 'Filename',
    type: 'Type',
    comments: 'Comments',
    uploadedAt: 'Uploaded at',
    openTitle: 'Open in a new tab',
    showing: 'Showing',
    of: 'of',
    documents: 'documents',
    previousPage: 'Previous page',
    nextPage: 'Next page',
    page: 'Page',
    rowsPerPage: 'Rows per page'
  },
  open: {
    preparing: 'Preparing your document',
    preparingHint: 'This can take a few seconds.',
    opened: 'Your document is ready',
    openAgain: 'Open or download it again',
    backToList: 'Back to the list of documents',
    unavailable: 'This document is no longer available.',
    timedOut: 'The document is taking too long to prepare.',
    failed: 'The document could not be opened.',
    rateLimited: 'Too many requests. Please wait a moment and try again.',
    retry: 'Try again'
  },
  notFound: {
    heading: 'This link is not available',
    body: 'The link may have been switched off, or never existed. Ask the person who shared it for a new one.'
  }
} as const;
